import React, { useEffect } from 'react';
import { CheckCircle2 } from 'lucide-react';

interface SuccessDialogProps {
    isOpen: boolean;
    message: string;
    onClose: () => void;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({ isOpen, message, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                onClose();
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div 
                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                onClick={onClose}
            />
            <div className="relative bg-[#0f0d15] border border-green-500/20 rounded-xl p-6 max-w-sm w-full mx-4 shadow-xl animate-success-entry">
                <div className="flex flex-col items-center text-center space-y-4">
                    <div className="rounded-full bg-green-500/10 p-3">
                        <CheckCircle2 className="w-8 h-8 text-green-500 animate-success-check" />
                    </div>
                    <h3 className="text-xl font-semibold text-white">Success!</h3>
                    <p className="text-gray-400">{message}</p>
                </div>
            </div>
        </div>
    );
};

export default SuccessDialog;